/**
 * Keeps values used among timetable components.
 * These need to be changed at the same time in order to retain the layout and functionalities
 */

export const oneHourSlotHeight = 85;
export const columnWidth = "125px";
export const columnMargin = "0px";
export const columnPadding = "0px";
export const columnBorderRadius = "8px";
export const oneandhelfHourSlotHeight = 150;
